import { jsx as _jsx } from "react/jsx-runtime";
import { ToastContainer, toast } from 'react-toastify';
import { styled } from 'styled-components';
import { InfoIcon, CloseButton, Message } from './common.js';
export { injectStyle as injectNotificationsStyle } from 'react-toastify/dist/inject-style';
export { AppBarNotification } from './AppBar.js';
export { InlineNotification as Notification } from './Inline.js';
const StyledContainer = styled(ToastContainer) `
  /* stylelint-disable selector-class-pattern */

  /* https://styled-components.com/docs/faqs#how-can-i-override-styles-with-higher-specificity */
  &&&.Toastify__toast-container {
    top: 12px;
    width: fit-content;
    min-width: 320px;
  }

  .Toastify__toast {
    font-family: inherit;
    box-shadow: none;
    border-radius: 8px;
    min-height: 36px;
    max-height: none;

    &.Toastify__toast--success {
      background-color: ${({ theme }) => theme.colors.positive10};
      border: 1px solid ${({ theme }) => theme.colors.positive30};
    }

    &.Toastify__toast--error {
      background-color: ${({ theme }) => theme.colors.critical10};
      border: 1px solid ${({ theme }) => theme.colors.critical30};
    }

    &.Toastify__toast--info {
      background-color: ${({ theme }) => theme.colors.link10};
      border: 1px solid ${({ theme }) => theme.colors.link30};
    }

    &.Toastify__toast--warning {
      background-color: ${({ theme }) => theme.colors.warning10};
      border: 1px solid ${({ theme }) => theme.colors.warning30};
    }
  }

  .Toastify__toast-body {
    padding: 0;
    align-items: normal;
  }
  /* stylelint-enable selector-class-pattern */
`;
const getCommonProps = ({ toastId, type, autoClose }) => ({
    icon: _jsx(InfoIcon, { type: type }),
    closeButton: CloseButton,
    toastId,
    autoClose,
});
export const useNotification = () => ({
    error: ({ title, body, type, toastId, autoClose }) => toast.error(_jsx(Message, { title: title, body: body, type: 'error' }), getCommonProps({ toastId, type, autoClose })),
    info: ({ title, body, type, toastId, autoClose }) => toast.info(_jsx(Message, { title: title, body: body, type: 'default' }), getCommonProps({ toastId, type, autoClose })),
    success: ({ title, body, type, toastId, autoClose }) => toast.success(_jsx(Message, { title: title, body: body, type: 'success' }), getCommonProps({ toastId, type, autoClose })),
    warn: ({ title, body, type, toastId, autoClose }) => toast.warn(_jsx(Message, { title: title, body: body, type: 'warning' }), getCommonProps({ toastId, type, autoClose })),
});
export const NotificationsContainer = () => _jsx(StyledContainer, { closeButton: CloseButton, position: 'top-center', hideProgressBar: true });
